const EmailIcon = () => {
    return (
        <svg 
            className="social-icon"
            xmlns="https://www.w3.org/2000/svg" 
            width="3.5rem" 
            viewBox="0 0 25 25" 
            stroke="whitesmoke" 
            stroke-width="1"
        >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
    )
}

export default EmailIcon;